module.exports = __webpack_public_path__ + "img/맥형아카데미_1.e9b77a40.jpg";